export default {"src":"/_next/static/media/stressMotivationMobile.d749acb6.svg","height":230,"width":272,"blurWidth":0,"blurHeight":0};